export const APP_RESIZE='APP_RESIZE'
export const APP_HOMEINFO='APP_HOMEINFO'

export const setHomeInfo=(json)=>{

  return ({
    type: APP_HOMEINFO,
    payload:json
  })
}



export const resize = ( contentHeight) => {
  return ({
    type: APP_RESIZE,
    payload : {contentHeight: contentHeight}
  })
}

